import Vue from "vue";
const vm = new Vue();
import * as types from "./mutation-types";

export const fetchAccounts = ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    try {
      vm.$api
        .get(`${vm.$endpoint.PERFORMANCE_SUMMARY}/${payload.account_id}`)
        .then((res) => {
          if (res.status == 200) {
            let msg = res.data.msg;
            commit(types.SET_STRATEGIES, res.data);
            commit(types.SET_MSG, msg);
            resolve();
          }
        });
    } catch (error) {
      reject();
    }
  });
};

export const detailsStrategy = ({ commit }, payload) => {
  commit(types.SET_DATE_RANGE, payload.date_range);

  return new Promise((resolve) => {
    vm.$api
      .get(
        `${vm.$endpoint.PERFORMANCE_INVESTMENT}/${payload.investment.investment_id}?start_date=${payload.date_range.start}&end_date=${payload.date_range.end}`
      )
      .then((res) => {
        let last_result = res.data.tr_history[0].result;
        let counter = -1;
        let newArray = res.data;

        function dateCurrent() {
          var today = new Date();
          var dd = String(today.getDate()).padStart(2, "0");
          var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
          var yyyy = today.getFullYear();
          today = yyyy + "-" + mm + "-" + dd;
          return today;
        }

        //
        newArray.tr_history.forEach((elem, index) => {
          if (typeof elem == "number") {
            elem = { result: elem, datetime: dateCurrent() };
          }

          counter++;

          if (counter == 0) {
            elem.diff = 0;
          } else {
            elem.diff = elem.result - last_result;
          }
          last_result = elem.result;
          //
          newArray.tr_history[index] = elem;
        });

        //
        let investment = [];

        investment = newArray;
        // investment.investment_portfolio = payload.portfolioName;
        investment.investment_name = payload.investment.investment_name;
        investment.investment_profit = payload.investment.investment_profit;

        commit(types.SET_INVESTMENT, investment);

        resolve();
      });
  });
};

export const logsStrategies = ({ commit, state }, payload) => {
  let limit = 25;
  let log_id = payload ? `&log_id=${payload}` : ``;

  return new Promise((resolve, reject) => {
    try {
      vm.$api
        .get(
          `${vm.$endpoint.PERFORMANCE_LOGS}/${state.investment.investment_id}?limit=${limit}${log_id}&start_date=${state.date_range.start}&end_date=${state.date_range.end}`
        )
        .then((res) => {
          if (res.status == 200) {
            if (res.data.length == 0) {
              commit(types.SET_LIMIT_LOGS, true);
              return;
            }
            commit(types.SET_LOGS_LIST, res);
            resolve();
          }
        });
    } catch (error) {
      commit(types.SET_MSG_LOGS, error.data.msg);
      reject();
    }
  });
};

export const destroyLogs = ({ commit }) => {
  commit(types.DESTROY_LOGS);
};

export const orderStrategies = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    let limit = 25;
    let index_id = state.investment.orders.length - 1;
    let order_id = state.investment.orders[index_id].order_id;
    vm.$api
      .get(
        `${vm.$endpoint.PERFORMANCE_ORDER_LIST}/${
          state.investment.investment_id
        }?from_order_id=${parseInt(order_id)}&limit=${limit}&start_date=${
          state.date_range.start
        }&end_date=${state.date_range.end}`
      )
      .then((res) => {
        commit(types.SET_ORDERS, res);
        resolve();
      })
      .catch((error) => {
        reject();
      });
  });
};

export const orderDetails = ({ commit, state }, payload) => {
  return new Promise((resolve) => {
    let { order_id, investment_id } = payload;
    vm.$api
      .get(
        `${vm.$endpoint.PERFORMANCE_ORDER_INFO}/${investment_id}/${order_id}`
      )
      .then((response) => {
        commit(types.SET_ORDERS_INFO, response.data);
        resolve(response);
      });
  });
};
